import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="pb-28 lg:pb-0">
      <div className="max-w-3xl mx-auto px-4 py-12 lg:py-20">
        <nav className="text-sm font-mono text-muted-foreground mb-6">
          <Link to="/" className="hover:text-accent">Home</Link>
          <span className="mx-2">/</span>
          <span>Terms of Use</span>
        </nav>

        <h1 className="font-heading font-bold text-4xl lg:text-5xl mb-6">Terms of Use</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: June 2026</p>

        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <h2 className="font-heading font-bold text-2xl text-foreground">Acceptance of Terms</h2>
          <p>
            By accessing and using highestefficiencysolarcell.com, you agree to these terms of use. 
            If you do not agree, please do not use this site.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Content Disclaimer</h2>
          <p>
            The information on this site is provided for general informational purposes only. We make 
            every effort to ensure accuracy, but we do not guarantee that all information is current, 
            complete, or error-free. Solar panel specifications, prices, and availability may change 
            without notice.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Affiliate Relationships</h2>
          <p>
            This site participates in the Amazon Services LLC Associates Program. Product links on 
            this site may be affiliate links. See our{" "}
            <Link to="/affiliate-disclosure" className="text-accent hover:underline">Affiliate Disclosure</Link>{" "}
            for details.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">No Professional Advice</h2>
          <p>
            Content on this site does not constitute professional electrical, engineering, or 
            installation advice. Always consult a qualified professional for solar installation 
            and electrical work. Follow all local building codes and regulations.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Intellectual Property</h2>
          <p>
            All original content on this site is protected by copyright. You may not reproduce, 
            distribute, or create derivative works without prior written permission.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Limitation of Liability</h2>
          <p>
            We are not liable for any damages arising from your use of this site or reliance on 
            information provided here. Product purchases are made through third-party retailers 
            and are subject to their terms and policies.
          </p>

          <h2 className="font-heading font-bold text-2xl text-foreground">Changes to Terms</h2>
          <p>
            We reserve the right to update these terms at any time. Continued use of the site 
            constitutes acceptance of any changes.
          </p>
        </div>
      </div>
    </div>
  );
}